<template>
  <div class="space-tree">
    <tree :nodes="nodes" :setting="setting"
          @onClick="ztreeOnClick"
          @onCreated="handleCreated"/>
  </div>
</template>

<script>
import {getlistAtnStrureTree} from "@/network/fire-alarm-panel-network";
import tree from "vue-giant-tree";

export default {
  name: "areaTreeShow",
  components: {tree},
  props: {
    // 当前选中层对象
    selectTier: {
      type: Object
    },
    isOpen: {},
    spaceId: null,
    tree: {
      type: String,
      default: "space"
    },
    setting: {
      type: Object,
      default: () => {
        return {
          view: {
            showIcon: false
          },
          data: {
            key: {
              name: 'cnName'
            },
            simpleData: {
              enable: true,
              pIdKey: 'parentId'
            }
          },
        }
      }
    }
  },
  data() {
    return {
      nodes: [],
      //ztree对象
      ztreeObj: null,
      // 楼层-区域集合
      tierAreaList: [],
      // 避免直接修改父组件的值
      selectTierCopy: this.selectTier
    };
  },
  mounted() {
    this.initTree();
  },
  methods: {
    // 初始化树节点菜单
    initTree() {
      if (this.tree === 'space') {
        this.getlistAtnStrureTree().then(() => {
          this.setTierInfo()
        })
      }
    },
    // 更新内景图信息
    updateIndoorInfo() {
      this.changeIndoorInfo().then(() => {
        this.setTierInfo()
      })
    },
    // 设置当前选中楼层
    setTierInfo() {
      // 传递当前选中楼层对象
      if (this.tierAreaList.length != 0) {
        this.tierAreaList.forEach(item => {
          if (item.id == this.selectTierCopy.id) {
            this.selectTierCopy = item

          }
        })
      }
      this.changeTierInfo()
    },
    // 更新整个树节点
    async getlistAtnStrureTree() {
      await getlistAtnStrureTree().then(res => {
        if (res.code == 0) {
          if (res.data != null && res.data.length != 0) {
            let treeNodes = [];
            this.tierAreaList = []
            res.data.forEach(item => {
              let node = {}
              node.deviceId = item.deviceId;
              node.cnName = item.deviceName;
              node.children = [];
              if (item.atnStructure != null && item.atnStructure.length != 0) {
                item.atnStructure.forEach(item1 => {
                  // 保存层-区域对象集合
                  this.tierAreaList.push(item1)
                  // 处理成vue树节点菜单可识别的对象集合。ES6进行深度拷贝
                  let childrenNode = {...item1}
                  // ES6将对象的某一个属性删除。指向内存地址
                  Reflect.deleteProperty(childrenNode, 'children')
                  node.children.push(childrenNode)
                })
              }
              treeNodes.push(node)
            })
            this.nodes = treeNodes;
          }
        }
      })
    },
    // 更新内景图数据
    async changeIndoorInfo() {
      await getlistAtnStrureTree().then(res => {
        if (res.code == 0) {
          if (res.data != null && res.data.length != 0) {
            let tierAreaListCopy = []
            res.data.forEach(item => {
              if (item.atnStructure != null && item.atnStructure.length != 0) {
                item.atnStructure.forEach(item1 => {
                  // 保存层-区域对象集合
                  tierAreaListCopy.push(item1)
                })
              }
            })
            if(tierAreaListCopy.length!=0){
              this.tierAreaList = tierAreaListCopy
            }
          }
        }
      })
    },
    ztreeOnClick(evt, treeId, treeNode) {
      if(treeNode.children){
        // 设置为上一次选中
        let node = this.ztreeObj.getNodeByParam('id',this.selectTierCopy.id);
        this.ztreeObj.selectNode(node)
        return;
      }
      if (treeNode.id != null && treeNode.id != undefined) {
        this.selectTierCopy = treeNode;
      }
      this.setTierInfo()
      this.$emit('spaceChoose', treeNode, false)
    },
    handleCreated(ztreeObj) {
      this.ztreeObj = ztreeObj;
      this.getSelectNode();
    },
    getSelectNode() {
      let firstTree;
      if (this.spaceId) {
        firstTree = this.selectedSpace(this.ztreeObj.getNodes());
      } else {
        // 默认选中第一个子空间
        firstTree = this.firstChildren(this.ztreeObj.getNodes());
      }
      this.ztreeObj.selectNode(firstTree);
      if (firstTree !== undefined) {
        this.selectTierCopy = firstTree
        this.setTierInfo()
        this.$emit('spaceChoose', firstTree, true)
      }

    },
    firstChildren(firstTree) {
      if (firstTree !== undefined) {
        for( let item of firstTree ) {
          if (item !== undefined && item.children !== undefined && item.children.length > 0) {
            let children = this.firstChildren(item.children);
            if (children !== undefined && children.type !== 1) {
              return children;
            }
          } else {
            // 返回item
            if (item !== undefined && item.type !== 1) {
              return item;
            }
          }
        }
      }
    },
    selectedSpace(list) {
      for( let item of list ) {
        // 返回item
        if (item !== undefined && item.id === this.spaceId) {
          return item;
        } else {
          if (item !== undefined && item.children !== undefined && item.children.length > 0) {
            let children = this.selectedSpace(item.children);
            if (children !== undefined && children.id === this.spaceId) {
              return children;
            }
          }
        }
      }
    },
    // 调用父组件刷新整个树节点信息
    changeTierInfo() {
      this.$emit("changeTierInfo", this.selectTierCopy)
    },
  }
}
</script>

<style>
.space-tree {
  overflow: auto;
}

/*文字颜色*/
.space-tree .ztree span, .button:before {
  color: #FFFFFF;
  border-color: transparent transparent transparent #ffffff !important;
}
</style>
